<template>
    <div class="address">
        <div class="toolbar">
            <a-button @click="add">添加</a-button>
            <a-button @click="delBtn">删除</a-button>
        </div>
        <a-table
            :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
            :columns="columns"
            :loading="loading"
            :scroll="{ y: 520 }"
            :data-source="listData"
            :pagination="pagination"
        >
            <template slot="action" slot-scope="text, record">
                <a style="display: block" @click="editAddress(record)">编辑</a>
                <a style="display: block" @click="deleteAddress(record.id)">删除</a>
                <a style="display: block" @click="setDefault(record)">设为默认地址</a>
            </template>

            <div
                slot="defaultAddress"
                slot-scope="defaultAddress"
                style="display: flex; align-items: center; justify-content: center"
            >
                <div
                    :style="{
                        width: '8px',
                        height: '8px',
                        borderRadius: '50%',
                        backgroundColor: defaultAddress == 1 ? '#6DD400' : '#FF3232',
                        marginRight: '4px'
                    }"
                ></div>
                <span>{{ defaultAddress === '1' ? '是' : '否' }}</span>
            </div>
        </a-table>

        <a-modal :visible="visible" title="添加新地址" @cancel="handleCancel">
            <custom-form :panels="formOption" ref="addressForm" :fieldsValue="editItemValue"></custom-form>
        </a-modal>
    </div>
</template>

<script>
import { delAddress, getAddressList, addAddress, modifyAddress, setDefaultAddress } from '../../../common/api';
import customForm from '../../../components/custom-form.vue';
import { mapGetters } from 'vuex';

export default {
    components: { customForm },

    computed: {
        ...mapGetters(['userInfo']),

        userId() {
            return this.userInfo.id;
        },

        pagination() {
            return {
                total: this.listData.length,
                showQuickJumper: true,
                showSizeChanger: true,
                showTotal(total) {
                    return `总共${total}条`;
                },

                defaultCurrent: 1
            };
        }
    },

    data() {
        return {
            visible: false,
            loading: false,
            selectedRowKeys: [],
            columns: [
                { title: '收货人姓名', dataIndex: 'name', key: 'name', align: 'center' },
                { title: '手机号', dataIndex: 'phone', key: 'phone', align: 'center' },
                { title: '地址', dataIndex: 'address', key: 'address', align: 'center' },
                { title: '详细地址', dataIndex: 'detailAddress', key: 'detailAddress', align: 'center' },
                {
                    title: '默认地址',
                    dataIndex: 'defaultAddress',
                    key: 'defaultAddress',
                    align: 'center',
                    scopedSlots: { customRender: 'defaultAddress' }
                },
                {
                    title: '操作',
                    key: 'operation',
                    width: 150,
                    scopedSlots: { customRender: 'action' }
                }
            ],

            listData: [],

            formOption: [
                {
                    id: 'addAddress',
                    gutter: 0,
                    fieldGroup: [
                        [
                            {
                                type: 'select',
                                label: '地址信息',
                                field: 'dz',
                                span: 12,
                                labelCol: { span: 12 },
                                wrapperCol: { span: 11 },
                                items: [
                                    { label: '湖北', value: '1' },
                                    { label: '湖南', value: '2' }
                                ],
                                rules: [{ required: true, message: '请输入地址信息' }]
                            },
                            {
                                type: 'select',
                                field: 'dz1',
                                span: 6,
                                labelCol: { span: 2 },
                                wrapperCol: { span: 22 },
                                items: [
                                    { label: '湖北', value: '1' },
                                    { label: '湖南', value: '2' }
                                ],
                                rules: [{ required: true, message: '请输入地址信息' }]
                            },
                            {
                                type: 'select',
                                field: 'dz2',
                                span: 6,
                                labelCol: { span: 0 },
                                wrapperCol: { span: 24 },
                                items: [
                                    { label: '湖北', value: '1' },
                                    { label: '湖南', value: '2' }
                                ],
                                rules: [{ required: true, message: '请输入地址信息' }]
                            }
                        ],
                        [
                            {
                                type: 'textarea',
                                label: '详细地址',
                                field: 'dh',
                                placeholder: '请输入',
                                labelCol: { span: 6 },
                                wrapperCol: { span: 18 },
                                rules: [{ required: true, message: '请输入详细地址' }]
                            },
                            {
                                label: '邮政编码',
                                field: 'yz',
                                placeholder: '请输入',
                                labelCol: { span: 6 },
                                wrapperCol: { span: 18 }
                            },
                            {
                                label: '收货人姓名',
                                field: 'shrxm',
                                placeholder: '请输入',
                                labelCol: { span: 6 },
                                wrapperCol: { span: 18 },
                                rules: [{ required: true, message: '请输入收货人姓名' }]
                            },
                            {
                                label: '手机号码',
                                field: 'phone',
                                placeholder: '请输入',
                                labelCol: { span: 6 },
                                wrapperCol: { span: 18 },
                                rules: [{ required: true, message: '请输入手机号码' }]
                            },
                            {
                                type: 'radioGroup',
                                label: '设为默认地址',
                                field: 'sd',
                                labelCol: { span: 6 },
                                wrapperCol: { span: 18 },
                                items: [
                                    { label: '是', value: '1' },
                                    { label: '否', value: '2' }
                                ]
                            }
                        ]
                    ]
                }
            ],

            editItemValue: {}
        };
    },

    mounted() {
        this.getList();
    },

    methods: {
        onSelectChange(selectedRowKeys) {
            this.selectedRowKeys = selectedRowKeys;
        },

        add() {
            this.visible = true;
        },

        delBtn() {
            if (!this.selectedRowKeys.length) {
                return this.$message.warning('请至少选择一条数据');
            }
            const idArr = this.selectedRowKeys.map(t => ({ id: t }));
            this.deleteAddress(idArr);
        },

        handleCancel() {
            this.visible = false;
        },

        async handleOk() {
            if (this.isEdit) {
                this.$message.success('修改成功！');
                await modifyAddress(this.editItemValue);
            } else {
                const { data } = await addAddress(this.userId);
                this.validateForm();
                const params = {
                    id: data,
                    ...this.editItemValue
                };
                await modifyAddress(params).then(() => {
                    this.$message.success('新增成功！');
                    this.getList();
                });
            }
            this.$refs['addressForm'].form.resetFields();
            this.resetFieldsValue();
        },

        resetFieldsValue() {
            for (const key in this.editItemValue) {
                this.editItemValue[key] = '';
            }
        },

        validateForm() {
            const form = this.$refs['addressForm'].form;
            form.validateFields((err, values) => {
                if (!err) {
                    for (const key in values) {
                        if (values[key]) {
                            this.editItemValue[key] = values[key];
                        }
                    }
                }
            });
        },

        async getList() {
            this.loading = true;
            const { data } = await getAddressList({ f: { userId_EQ: this.userId }, n: -1 });
            this.listData = data.rows.map(t => {
                return { ...t, key: t.id };
            });
            this.loading = false;
        },

        async deleteAddress(params) {
            const isArray = typeof params === 'object';
            const _this = this;
            this.$confirm({
                title: '提示',
                content: isArray ? '确定要删除已勾选的地址吗？' : '确定要删除当前地址吗？',
                async onOk() {
                    let idArr = isArray ? params : [{ id: params }];
                    await delAddress(idArr);
                    _this.$message.success('删除地址成功！');
                    _this.getList();
                }
            });
        },

        async editAddress() {
            this.visible = true;
        },

        async setDefault(record) {
            if (record.defaultAddress === '1') {
                return;
            }
            await setDefaultAddress(record.id);
            this.$message.success('默认地址修改成功！');
            this.getList();
        }
    }
};
</script>

<style lang="scss" scoped>
.address {
    width: 950px;
    min-height: 300px;

    .toolbar {
        width: 100%;
        height: 48px;
        text-align: right;
        line-height: 48px;

        .ant-btn {
            margin: 0 4px;
            border: 1px solid rgba(217, 217, 217, 1);
            font-size: 14px;
            color: #333333;
        }
    }
}
</style>
